import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path:'/',
		redirect: '/index'
	},
	{
		name:'index',
		path:'/index',
		component:index
	}
]

const router = new VueRouter({
  mode: 'history',
  base: '/vote21/',
  routes
})

export default router
